export default __webpack_public_path__ + "static/media/fb_icon.c607991d.svg";